import React, { useState } from 'react';
import logo from './logo-web.png';
import './App.css';

function PrivacyPolicy() {
  const [language, setLanguage] = useState('FR');

  const switchLanguage = () => {
    setLanguage((prevLanguage) => (prevLanguage === 'FR' ? 'EN' : 'FR'));
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} style={{ height: 200 }} alt="logo" />
        <button onClick={switchLanguage} style={{ margin: '20px', padding: '10px', fontSize: '16px' }}>
          {language === 'FR' ? 'Switch to English' : 'Passer au français'}
        </button>
        <p className="legacyP">
          {language === 'FR' ? (
            <>
              <section>
                <h2>1. Introduction</h2>
                <p>
                  Bienvenue dans <strong>MathemaKids</strong>, une application conçue pour aider les enfants à
                  apprendre les tables de multiplication en s’amusant. La confidentialité de nos utilisateurs, en
                  particulier celle des enfants, est une priorité absolue. Nous nous engageons à protéger vos données
                  conformément aux réglementations applicables, y compris les directives de l’App Store pour la
                  catégorie Kids.
                </p>
              </section>

              <section>
                <h2>2. Données collectées</h2>
                <p>
                  <strong>MathemaKids</strong> utilise <strong>Firebase Analytics</strong>, un outil d’analyse tiers,
                  pour collecter des données anonymes sur l’utilisation de l’application. Ces données sont collectées
                  afin d’améliorer l’expérience utilisateur et les fonctionnalités de l’application.
                </p>
                <h3>Détails des données collectées :</h3>
                <ul>
                  <li>Interactions avec l’application (par exemple, fonctionnalités utilisées, temps passé).</li>
                  <li>Événements anonymisés (comme le démarrage d’un entraînement ou l’affichage d’une page spécifique).</li>
                </ul>
                <h3>Données non collectées :</h3>
                <ul>
                  <li>Aucune donnée personnelle identifiable (nom, email, adresse, etc.) n’est collectée.</li>
                  <li>Aucune donnée relative à l’appareil (numéro unique, identifiant publicitaire) n’est utilisée.</li>
                </ul>
                <p>
                  Les données collectées par Firebase Analytics ne sont jamais partagées avec des tiers, en dehors des
                  services fournis par Firebase. Pour plus de détails, vous pouvez consulter la{' '}
                  <a
                    href="https://firebase.google.com/support/privacy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Politique de confidentialité de Firebase
                  </a>
                  .
                </p>
              </section>

              <section>
                <h2>3. Utilisation de l’application</h2>
                <p>
                  Toutes les fonctionnalités de <strong>MathemaKids</strong> sont disponibles sans qu’aucune donnée
                  personnelle identifiable ne soit collectée. Les données collectées via Firebase Analytics sont
                  strictement limitées à des informations anonymes utilisées pour améliorer l’application. Aucune donnée
                  utilisateur n’est stockée ou transférée vers des serveurs externes, à l’exception de celles gérées par
                  Firebase, conformément à leur politique de confidentialité.
                </p>
              </section>

              <section>
                <h2>4. Conformité avec la catégorie Kids</h2>
                <p>
                  Nous avons conçu <strong>MathemaKids</strong> pour respecter toutes les exigences de la catégorie Kids
                  de l’App Store :
                </p>
                <ul>
                  <li>L’application ne contient aucune publicité.</li>
                  <li>Les données collectées sont minimales et anonymisées.</li>
                  <li>Aucune donnée personnelle des enfants n’est collectée ou partagée.</li>
                </ul>
              </section>

              <section>
                <h2>5. Contact</h2>
                <p>
                  Pour toute question relative à cette politique de confidentialité, veuillez nous contacter à l'adresse
                  suivante :
                </p>
                <p>
                  <strong>Nans Gigan</strong>
                  <br />
                  📧 Email : <a href="mailto:nans@gigan.fr">nans@gigan.fr</a>
                </p>
              </section>

              <section>
                <h2>6. Modifications de la politique de confidentialité</h2>
                <p>
                  Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute
                  modification importante sera communiquée aux utilisateurs via une mise à jour de l’application ou une
                  notification sur notre site.
                </p>
              </section>
            </>
          ) : (
            <>
              <section>
                <h2>1. Introduction</h2>
                <p>
                  Welcome to <strong>MathemaKids</strong>, an application designed to help children learn multiplication
                  tables while having fun. The privacy of our users, especially children, is our top priority. We are
                  committed to protecting your data in compliance with applicable regulations, including the App Store’s
                  Kids category guidelines.
                </p>
              </section>

              <section>
                <h2>2. Data Collected</h2>
                <p>
                  <strong>MathemaKids</strong> uses <strong>Firebase Analytics</strong>, a third-party analytics tool, to
                  collect anonymous data about the application’s usage. This data is collected to improve user
                  experience and enhance the application’s features.
                </p>
                <h3>Details of Collected Data:</h3>
                <ul>
                  <li>Interactions with the application (e.g., features used, time spent).</li>
                  <li>Anonymous events (e.g., starting a training session or viewing a specific page).</li>
                </ul>
                <h3>Data Not Collected:</h3>
                <ul>
                  <li>No personally identifiable information (name, email, address, etc.) is collected.</li>
                  <li>No device-specific information (unique ID, advertising identifier) is used.</li>
                </ul>
                <p>
                  The data collected by Firebase Analytics is never shared with third parties except for services
                  provided by Firebase. For more details, please refer to{' '}
                  <a
                    href="https://firebase.google.com/support/privacy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Firebase's Privacy Policy
                  </a>
                  .
                </p>
              </section>

              <section>
                <h2>3. Use of the Application</h2>
                <p>
                  All features of <strong>MathemaKids</strong> are available without collecting any personally
                  identifiable information. Data collected through Firebase Analytics is strictly limited to anonymous
                  information used to improve the application. No user data is stored or transferred to external servers
                  except for those managed by Firebase, in accordance with their privacy policy.
                </p>
              </section>

              <section>
                <h2>4. Compliance with Kids Category</h2>
                <p>
                  We have designed <strong>MathemaKids</strong> to comply with all requirements of the App Store's Kids
                  category:
                </p>
                <ul>
                  <li>The application contains no advertisements.</li>
                  <li>Data collected is minimal and anonymized.</li>
                  <li>No children’s personal data is collected or shared.</li>
                </ul>
              </section>

              <section>
                <h2>5. Contact</h2>
                <p>
                  For any questions regarding this privacy policy, please contact us at the following address:
                </p>
                <p>
                  <strong>Nans Gigan</strong>
                  <br />
                  📧 Email: <a href="mailto:nans@gigan.fr">nans@gigan.fr</a>
                </p>
              </section>

              <section>
                <h2>6. Privacy Policy Changes</h2>
                <p>
                  We reserve the right to modify this privacy policy at any time. Any significant changes will be
                  communicated to users via an application update or notification on our site.
                </p>
              </section>
            </>
          )}
        </p>
      </header>
    </div>
  );
}

export default PrivacyPolicy;